<template>
  <div ref="riskline" class="pbr-index-chart">
<Empty></Empty>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../../../analysis/constant'
import Mixin from '../mixin'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartRiskLine',
  inject: ['chartDatas'],
  mixins: [Mixin],
  props:{
    height: { type: Number }
  },
  data () {
    return {
      risklineChart: null,
      optionriskline: null,
      isResize: false,
    }
  },
  computed: {
    chartData () {
      const riskChartData = this.chartDatas.riskChartData()
      if (riskChartData.hasOwnProperty('riskLineChart') && riskChartData.riskLineChart.length > 0) {
        return riskChartData.riskLineChart
      }
      return [{name: '', nums: [0], times: [0]}]
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if(!this.$refs.riskline){
        return
      }
      if (this.risklineChart) {
        this.risklineChart.dispose()
      }
      let countContrastDom = this.$refs.riskline
      this.risklineChart = echarts.init(countContrastDom, theme, {devicePixelRatio: 2.5})
      this.risklineChart.setOption(this.optionriskline)
      this.risklineChart.on('click', (param) => {
        // this.$emit('project-count-chart-click', param)
        // self.dispatch('pbrIndex', 'filterData', {module: 'xm', countryName: param.name})
      })

      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.risklineChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      let that = this
      this.optionriskline = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: that.$t('charts.home.risk.trend'),
          left: 'center',
          top:0
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        legend: {
          type: 'scroll',
          data: this.chartData.map(d => d.name),
          itemHeight: 8,
          itemWidth: 15,
          top: 20
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 0,
          top: this.showTitle ? 50 : 20,
          containLabel: true
        },

        // dataset: this.chartData.map(d => { return { source: d.countArr } }),
        xAxis: { type: 'category', data: [...new Set(this.chartData.map(d => d.times).reduce((pre, cur) => pre.concat(cur)))] },
        yAxis: { type: 'value',min: function (value) {
            let num = 0
            if (value.min === 0) {
              return num
            } else if (value.min.toString().length < 2) {
              return value.min - 1
            } else if (value.min.toString().length < 3) {
              return value.min - 10
            } else {
              num = 10 ** (value.min.toString().length - 2)
              return Math.floor(value.min / num) * num
            }
          } },
        series: this.chartData.map((d, i) => {
          return {
            name: d.name,
            type: 'line',
            data: d.nums,
            areaStyle: {opacity:.1},
            smooth:true
          }
        })
      }
    },
    resize () {
      this.isResize = true
      this.risklineChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue.length === 0) {
          if (this.risklineChart) {
            this.risklineChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
